/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigate} from "react-router-dom";
import {RouteConstant} from "@/util/constant/RouteConstant.ts";
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import Successful from "../../../public/assets/lotties/successful.json"
import {readReadByUserId} from "@/store/modules/readByUserId.ts";
import Lottie from "lottie-react";

export default function SuccessLogin() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const userInfo = useSelector(
    //     (state: RootState) => state.readByUserId.userInfo
    // );
    // const loading = useSelector((state: RootState) => state.readByUserId.loading);

    function gotoDashboard() {
        navigate(RouteConstant.dashboard.dashboard.path);
    }

    useEffect(() => {
        dispatch<any>(readReadByUserId({data: ""}));
    }, [dispatch]);

    return (
        <div className="utility-page_component">
            <Lottie animationData={Successful} style={{width: "200px", height: "200px"}} loop={true}/>
            <h3 style={{fontWeight: "500"}}>Login Successful🥳</h3>
            <div style={{fontWeight: "300", width: "300px", textAlign: "center", fontSize: "14px"}}>
                You have successfully Logged in to your Qoonity account
            </div>
            <a
                className="button w-button"
                style={{minWidth: "356px", padding: "10px", borderRadius: "10px"}}
                onClick={() => gotoDashboard()}
            >
                Proceed to Dashboard
            </a>
        </div>
    );
}

{/*{loading && <div>Loading user details...</div>}*/
}
{/*{userInfo && (*/
}
{/*    <div*/
}
{/*        style={{*/
}
{/*            fontWeight: "300",*/
}
{/*            width: "300px",*/
}
{/*            textAlign: "center",*/
}
{/*            marginLeft: "580px",*/
}
{/*            fontSize: "14px",*/
}
{/*        }}*/
}
{/*    >*/
}
{/*        <p>Workspace ID: {userInfo.workspaceId}</p>*/
}
{/*        <p>Workspace Name: {userInfo.workspaceName}</p>*/
}
{/*        <p>Workspace Description: {userInfo.workspaceDescription}</p>*/
}
{/*        <p>Subscription Plan ID: {userInfo.workspaceSubscriptionPlanId}</p>*/
}
{/*        <p>Status: {userInfo.workspaceStatus}</p>*/
}
{/*        <p>Created At: {userInfo.workspaceCreatedAt}</p>*/
}
{/*        <p>Updated At: {userInfo.workspaceUpdatedAt}</p>*/
}
{/*    </div>*/
}
{/*)}*/
}
